import * as React from "react";

import reactCSS from 'reactcss'
import {css,cx} from "emotion";
import {ReactUtilities} from "shared/utilities/react/ReactUtilities";


export class FontSizeButton extends React.Component<FontSizeButtonProps, FontSizeButtonState> {
    static defaultProps: Partial<FontSizeButtonProps> = {
        Sizes:[8,9,10,11,12,14,16,18,20,22,24,26,28,36,48,72]
    };

    public Input:HTMLInputElement;

    constructor(props: FontSizeButtonProps) {
        super(props);
        this.state = {
            CurrentValue:this.props.FontSize.toString(),
            DropdownIsOpen:false
        };
    }

    public componentWillReceiveProps(nextProps: Readonly<FontSizeButtonProps>, nextContext: any): void {
        if(this.state.CurrentValue!=nextProps.FontSize as any)
        {
            this.setState({CurrentValue:nextProps.FontSize as any})
        }
    }



    public render() {

        let mainControl=css`          
          position:relative;
        `;

        return (
            <div  className={mainControl} style={{marginLeft:5}}>
                <input ref={node=>this.Input=node as any}  onBlur={e=>this.setState({DropdownIsOpen:false})} onFocus={e=>this.setState({DropdownIsOpen:true})} style={{width:90,height:25}} type={'text'} value={this.state.CurrentValue} onChange={e=>this.InputChanged(e)} onKeyPress={e=>e.key=='Enter'&&this.ApplyChange(this.state.CurrentValue)}/>

                {this.state.DropdownIsOpen&&
                <ul style={{backgroundColor:'white',width:'100%',margin:0,position:'absolute',height:120,overflowY:'scroll',padding:5,zIndex:10}}>
                    {this.props.Sizes.map(x=>
                        <li onMouseDown={e=>this.ApplyChange(x.toString())} className={css`
                              cursor:pointer;
                              margin:0;
                              padding:2px 12px;
                              &:hover{
                                  background-color: #189ad3;
                                  color:white;
                              }`
                        } value={x} key={x}>{x}</li>
                    )}
                </ul>}
            </div>
        )
    }

    private InputChanged(e: React.ChangeEvent<HTMLInputElement>) {
        if(e.target.value=='')
            this.setState({CurrentValue:''});
        let value=parseInt(e.target.value);
        if(isNaN(value))
            return;
        this.setState({CurrentValue:value.toString()});
    }

    private ApplyChange(CurrentValue: string) {

        let number=parseInt(CurrentValue);
        if(isNaN(number))
        {
            return;
        }

        this.setState({CurrentValue:number.toString(),DropdownIsOpen:false});
        ReactUtilities.ExecuteMethodPropIfDefined(this.props.SizeChanged,number);
        if(this.Input!=null)
            this.Input.blur();
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FontSizeButtonProps {
    Sizes:number[];
    FontSize:number;
    SizeChanged:(size:number)=>void;
}

interface FontSizeButtonState {
    CurrentValue:string;
    DropdownIsOpen:boolean;
}

//#endregion "My Region"